/** People who already see estimated tips, cash tips, or the Tips report. */
export const TIP_POOL_PERMISSIONS = [
	"view_estimated_tips",
	"view_cash_tips",
	"view_report_tips",
];
